// Top-level account-global admin area. The shell lives at `/admin`, whose index
// is the admin home; each tab is a child route. New admin tabs are a one-line
// addition here + in `getAdminTools` (admin-tools.ts) + a child in routes.ts.
export const ADMIN_URL = 'admin'
export const FEATURE_FLAGS_URL = 'feature-flags'
export const NLP_PROMPT_CATALOG_URL = 'nlp-prompt-catalog'
export const SOURCE_CATALOG_URL = 'source-catalog'
export const PROJECT_SCHEDULES_URL = 'schedule'
export const FEED_AUDIT_URL = 'feed-audit'
export const EXPORT_GROUPS_URL = 'export-groups'
export const INGESTION_RUNS_URL = 'ingestion-runs'
export const SYNDICATED_SOURCE_PROMOTIONS_URL = 'syndicated-source-promotions'
export const HUB_INTEGRITY_URL = 'data-integrity'
